import { IRSState } from './types';

export const initialState: IRSState = {
  bestPlaceAnalyticsReportExampleUrl: '',
  bestPlaceReportLegalDocsUrl: '',
  bestPlaceReportBaseUrl: '',
  bestPlaceReportProviderInfo: '',
  isPerformanceVasPilot: false,
  kpnChat: {
    enabled: false,
  },
  isCpcAuctionEnabled: false,
};

export function rsReducer(state: IRSState = initialState): IRSState {
  return state;
}
